/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Table_Totalgames1Inputs */

const id_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Game Tunggal`)
};

const ms_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah Permainan Tunggal`)
};

const da_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlede Enkeltspil`)
};

const de_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Einzelspiele`)
};

const en_us2_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Single Games`)
};

const es_es2_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de juegos individuales`)
};

const es_mx2_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de juegos individuales`)
};

const fil_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang Indibidwal na Laro`)
};

const fr_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total jeux individuels`)
};

const it_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale giochi singoli`)
};

const hu_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes egyedi játék`)
};

const nl_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal enkele spellen`)
};

const no_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antall enkeltspill`)
};

const pl_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba pojedynczych gier`)
};

const pt_br2_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de jogos individuais`)
};

const pt_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de jogos individuais`)
};

const ro_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total jocuri individuale`)
};

const fi_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksittäisten pelien kokonaismäärä`)
};

const sv_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal enskilda spel`)
};

const vi_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số game riêng lẻ`)
};

const tr_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam Tekil Oyun`)
};

const cs_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem jednotlivých her`)
};

const bg_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общо отделни игри`)
};

const ru_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего отдельных игр`)
};

const uk_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усього окремих ігор`)
};

const ar_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الألعاب الفردية`)
};

const hi_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल एकल गेम`)
};

const th_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวมเกมเดี่ยว`)
};

const ja_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計単体ゲーム数`)
};

const zh_cn2_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单机游戏总数`)
};

const zh_hant1_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`單機遊戲總數`)
};

const ko_freebies_table_totalgames1 = /** @type {(inputs: Freebies_Table_Totalgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 단일 게임`)
};

/**
* | output |
* | --- |
* | "Total Single Games" |
*
* @param {Freebies_Table_Totalgames1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_table_totalgames1 = /** @type {((inputs?: Freebies_Table_Totalgames1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Table_Totalgames1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_table_totalgames1(inputs)
	if (locale === "ms") return ms_freebies_table_totalgames1(inputs)
	if (locale === "da") return da_freebies_table_totalgames1(inputs)
	if (locale === "de") return de_freebies_table_totalgames1(inputs)
	if (locale === "en-US") return en_us2_freebies_table_totalgames1(inputs)
	if (locale === "es-ES") return es_es2_freebies_table_totalgames1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_table_totalgames1(inputs)
	if (locale === "fil") return fil_freebies_table_totalgames1(inputs)
	if (locale === "fr") return fr_freebies_table_totalgames1(inputs)
	if (locale === "it") return it_freebies_table_totalgames1(inputs)
	if (locale === "hu") return hu_freebies_table_totalgames1(inputs)
	if (locale === "nl") return nl_freebies_table_totalgames1(inputs)
	if (locale === "no") return no_freebies_table_totalgames1(inputs)
	if (locale === "pl") return pl_freebies_table_totalgames1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_table_totalgames1(inputs)
	if (locale === "pt") return pt_freebies_table_totalgames1(inputs)
	if (locale === "ro") return ro_freebies_table_totalgames1(inputs)
	if (locale === "fi") return fi_freebies_table_totalgames1(inputs)
	if (locale === "sv") return sv_freebies_table_totalgames1(inputs)
	if (locale === "vi") return vi_freebies_table_totalgames1(inputs)
	if (locale === "tr") return tr_freebies_table_totalgames1(inputs)
	if (locale === "cs") return cs_freebies_table_totalgames1(inputs)
	if (locale === "bg") return bg_freebies_table_totalgames1(inputs)
	if (locale === "ru") return ru_freebies_table_totalgames1(inputs)
	if (locale === "uk") return uk_freebies_table_totalgames1(inputs)
	if (locale === "ar") return ar_freebies_table_totalgames1(inputs)
	if (locale === "hi") return hi_freebies_table_totalgames1(inputs)
	if (locale === "th") return th_freebies_table_totalgames1(inputs)
	if (locale === "ja") return ja_freebies_table_totalgames1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_table_totalgames1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_table_totalgames1(inputs)
	return ko_freebies_table_totalgames1(inputs)
});
export { freebies_table_totalgames1 as "freebies.table.totalGames" }